module.exports = __webpack_public_path__ + "static/img/home_capsule.f3bb44d3.gif";